import { render } from "./Slogan5.vue?vue&type=template&id=76188bfe&scoped=true&lang=true"
import script from "./Slogan5.vue?vue&type=script&lang=js"
export * from "./Slogan5.vue?vue&type=script&lang=js"

import "./Slogan5.vue?vue&type=style&index=0&id=76188bfe&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76188bfe"]])

export default __exports__